const hideFixibleElement = ({fixibleSelector = `.js-bottom-fix`, hideClass = `hide`}) => {
  const fixibleElement = document.querySelector(fixibleSelector);
  const footer = document.querySelector(`.footer`);

  const TRUNCATION = 50;

  const scrollHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight,
  );

  const changeHideClass = () => {
    if (
      window.innerHeight + window.scrollY >=
      footer.getBoundingClientRect().bottom - TRUNCATION + window.scrollY
    ) {
      fixibleElement.classList.add(hideClass);
    } else {
      fixibleElement.classList.remove(hideClass);
    }
  };

  if (fixibleElement) {
    window.addEventListener(`load`, (evt) => {
      if (scrollHeight <= window.innerHeight + window.scrollY) {
        fixibleElement.classList.remove(hideClass);
        footer.style.paddingBottom = `${fixibleElement.getBoundingClientRect().height + 10}px`;
      } else {
        changeHideClass();
        window.addEventListener(`scroll`, changeHideClass);
      }
    });
  }
};

export default hideFixibleElement;
